import { Component, OnInit, AfterViewInit } from '@angular/core';
import { locale as en } from '../i18n/en'
import { locale as fr } from '../i18n/fr'
import { locale as de } from '../i18n/de'
import { locale as pt } from '../i18n/pt'
import { locale as sp } from '../i18n/sp'
import { CoreTranslationService } from '@core/services/translation.service';
import Stepper from 'bs-stepper';
import { BitsoService } from '../services/bitso.service';
import { ClientBitsoInfo, ClientInfoResponse, ConfirmacionBodyBitsoResponse, CotizacionCryptoBitsoRequest, CriptoActivoBitso } from '../services/modelos/ClientBitsoInfo';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';



@Component({
  selector: 'app-activos',
  templateUrl: './activos.component.html',
  styleUrls: ['./activos.component.scss']
})
export class ActivosComponent implements OnInit, AfterViewInit {
  public contentHeader: object;
  private horizontalWizardStepper: Stepper;
  cotizacionForm: FormGroup;
  cotizacionRespuesta: CotizacionCryptoBitsoRequest | null = null;
  cotizacionConfirmacion: ConfirmacionBodyBitsoResponse | null = null;
  alertClose = true;
  alertCloseInformacionDeCliente = true;
  alertCloseBalanceBitso = true;

  constructor(
    private _coreTranslationService: CoreTranslationService,
    private bitsoService: BitsoService,
    private fb: FormBuilder
  ) {
    this._coreTranslationService.translate(en, fr, de, pt, sp);
  }
  client: ClientBitsoInfo = new ClientBitsoInfo();
  criptoactivos: CriptoActivoBitso[] = [];

  ngOnInit(): void {
    this.contentHeader = {
      headerTitle: 'Bitso',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/'
          },
          {
            name: 'Bitso',
            isLink: false
          }
        ]
      }
    };
    
    this.cotizacionForm = this.fb.group({
      from_currency: ['', Validators.required],
      to_currency: ['', Validators.required],
      from_amount: [null, [Validators.required, Validators.min(0.00000001)]]
    });

  }

  ngAfterViewInit(): void {
    const element = document.querySelector('#stepper1');
    if (element) {
      this.horizontalWizardStepper = new Stepper(element, {
        linear: false,
        animation: true
      });
    } else {
      console.warn('Stepper element not found!');
    }
  }

  // Métodos opcionales para avanzar y retroceder
  nextStep(): void {
    this.horizontalWizardStepper.next();
  }

  previousStep(): void {
    this.horizontalWizardStepper.previous();
  }


  // Método que se llama cuando el usuario hace clic en "Obtener Cotización"
  obtenerCotizacion() {
    if (this.cotizacionForm.valid) {

      const formValue = this.cotizacionForm.value;
      const cotizacionRequest: CotizacionCryptoBitsoRequest = {
        ...formValue,
        from_currency: formValue.from_currency.trim(),
        to_currency: formValue.to_currency.trim()
      };
      this.bitsoService.obtenerCotizacion(cotizacionRequest).subscribe(
        (response: CotizacionCryptoBitsoRequest) => {
          this.cotizacionRespuesta = response;
          this.alertClose = true;
        },
        (error) => {
          console.error('Error al obtener cotización:', error);
        }
      );
    }
  }

  // Método para confirmar la cotización
  confirmarCotizacion() {
    if (this.cotizacionRespuesta && this.cotizacionRespuesta.id) {
      this.bitsoService.confirmarCotizacion(this.cotizacionRespuesta).subscribe(
        (response: ConfirmacionBodyBitsoResponse) => {
          this.cotizacionConfirmacion = response;
          this.alertClose = false;
          console.log('Confirmación:', this.cotizacionConfirmacion);
        },
        (error) => {
          console.error('Error al confirmar cotización:', error);
        }
      );
    }
  }

  // Getter para acceder de forma más sencilla al formulario
  get f() {
    return this.cotizacionForm.controls;
  }


  // Método para confirmar la cotización
  obtenerInformacionDeCliente() {
    this.bitsoService.obtenerInfoClienteModel().subscribe({
      next: (data) => {
        this.client = data.payload;

        let rawDate = data.payload.date_of_birth // formato MM/DD/YYYY
        let dateParts = rawDate.split('/');
        this.client.date_of_birth = `${dateParts[2]}-${dateParts[0].padStart(2, '0')}-${dateParts[1].padStart(2, '0')}`;
        this.alertCloseInformacionDeCliente = true;
      },
      error: (err) => {
        this.alertCloseInformacionDeCliente = false;
      }
    });
  }
  obtenerBalanceBitso() {
    this.bitsoService.obtenerCriptoActivosBitso().subscribe({
      next: (data) => {
        this.criptoactivos = data;
        this.alertCloseBalanceBitso = true;
      },
      error: (err) => {
        this.alertCloseBalanceBitso = false;
      }
    });
  }

}

